import React, {PureComponent} from 'react'
import {map} from 'lodash-es'
import classNames from 'classnames'
import Slider from 'rc-slider/lib/Slider'

// Need to create custom marks because we need to catch their onclick
const marks = { 1: "", 2: "", 3: "", 4: "", 5: "" }

class AnswerOptions extends PureComponent {
  state = { hoverIndex: null }

  isSelected = (value) => this.state.answerIndex === value;

  answer = answerIndex => {
    const { answerQuestion, question } = this.props;
    answerQuestion(Number(answerIndex), question);
  }

  rate = rating => {
    const { rateQuestion, question } = this.props;
    rateQuestion(Number(rating), question);
  }

  skipQuestion = () => {
    this.answer(0);
    if(this.props.question.rate !== null) {
      this.rate(0);
    }
  }

  // fuck me...
  getRangeLabelStyles = (index) => {
    switch (Number(index)) {
      case 1:
        return {
          // left: "-5px",
        };
      case 2:
        return {
          // left: "18%",
          opacity: 0
        };
      case 3:
        return {
          // left: "40%",
          opacity: 0
        };
      case 4:
        return {
          // left: "67.5%",
          opacity: 0
        };
      case 5:
        return {
          // paddingLeft: '0px',
          // left: "90%",
          justifyContent: 'flex-end',
          textAlign: 'right',
          whiteSpace: 'nowrap'
        };
      default:
        break;
    }
  };

  render() {
    const { question, number, t, color } = this.props;
    const { response: answerIndex,  title, subTitle, lowEndLabel, highEndLabel } = question;

    const rangeStyles = classNames("slider-container", {
      "has-value": !!answerIndex,
    });

    const getRailAfterWidth = () => {
      switch (answerIndex) {
        case 1: {
          return 0;
        }
        case 2: {
          return 26;
        }
        case 3: {
          return 51;
        }
        case 4: {
          return 76;
        }
        case 5: {
          return 100;
        }
        default:
          break;
      }
    };

    const railAfterWidth = getRailAfterWidth();

    const answerOptions = [
      { index: 1, title: lowEndLabel },
      { index: 2, title: t('needs_improvement') },
      { index: 3, title: t('acceptable') },
      { index: 4, title: t('good') },
      { index: 5, title: highEndLabel },
    ]

    return (
      <div className="question-container" style={{ background: color }}>
        <div className="question-container__inner pb-3">
          <div className='d-flex justify-content-between align-items-start mb-2 question-intro'>
            <label className="question-title">
              {number}. {title}
            </label>
            <div className="position-relative no-concern-container d-flex align-items-center ml-5">
              <div
                className={`no-concern flex-shrink-0 ${answerIndex === 0 && "active"} mr-2`}
                onClick={() => this.skipQuestion()}
              ></div>
              <label className="no-concern-label mb-0">{t("no_concern")}</label>
            </div>
          </div>

          <div className="answer-options">
            <label className='question-subtitle mb-3'>{subTitle}</label>
            <div className="d-flex justify-content-center answer-options-container">
              <div className="w-100 position-relative">
                <div className={rangeStyles}>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: [
                        `.question-slider-${question.id} .rc-slider-rail:after {`,
                        `  width: ${railAfterWidth}% !important`,
                        "}",
                      ].join("\n"),
                    }}
                  ></style>
                  <Slider
                    step={1}
                    min={1}
                    max={5}
                    className={`question-slider-${question.id}`}
                    value={answerIndex}
                    marks={marks}
                  />
                </div>
                <div className="row range-labels">
                  {map(marks, (mark, index) => {
                    return (
                      <div
                        key={index}
                        onClick={this.answer.bind(this, index)}
                        className={"col range-label d-flex align-items-end"}
                        style={this.getRangeLabelStyles(index)}
                      >
                        {answerOptions[index - 1] &&
                          answerOptions[index - 1].title}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="w-100 mobile-selected-label d-flex justify-content-between align-items-center">
              <span className="pr-2">{answerOptions[0].title}</span>
              <span className="text-right pl-2">{answerOptions[answerOptions.length - 1].title}</span>
            </div>
          </div>
        </div>
          <div className="question-container__inner hearts-container">
          <div className={`answer-options heart-options`}>
              <h5 className="question-importance-title">{t("question_importance")}</h5>
              <div className="hearts-and-labels">
                <div className="hearts">
                  {map([1, 2, 3, 4, 5], (mark, index) => {
                    return (
                      <div
                        className={`heart ${answerIndex === 0 && 'disabled'}`}
                        onClick={() => this.rate(mark)}
                        onMouseEnter={() => this.setState({ hoverIndex: index })}
                        onMouseLeave={() => this.setState({ hoverIndex: null })}
                        key={index}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill={`${
                            (
                              (!(answerIndex === 0) && Number(question.rate) >= Number(index + 1))
                              ||
                              (this.state.hoverIndex > index)
                            )
                            ? "#F58220" : "none"}
                          `}
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          stroke={answerIndex === 0 ? '#C6CEDA' : '#F58220'}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                          />
                        </svg>
                      </div>
                    );
                  })}
                </div>
                <div className="hearts-labels">
                  <div className={"low-end-label"}>
                    {t("hearts_low_label")}
                  </div>
                  <div className={"high-end-label"}>
                    {t("hearts_high_label")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default AnswerOptions



// WEBPACK FOOTER //
// ./src/components/answer-options.js